import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './state/auth';
import { Topbar } from './components/layout/Topbar';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Dashboard } from './pages/Dashboard';
import { Themes } from './pages/Themes';
import { ThemeDetail } from './pages/ThemeDetail';
import { Lesson } from './pages/Lesson';
import { SelfScan } from './pages/SelfScan';
import { Toets } from './pages/Toets';
import { Voortgang } from './pages/Voortgang';
import { Certificaten } from './pages/Certificaten';

function App() {
  return (
    <AuthProvider>
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-canvas">
        <Topbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/themas" element={<Themes />} />
            <Route path="/thema/:themeId" element={<ThemeDetail />} />
            <Route path="/thema/:themeId/les/:moduleIdx" element={<Lesson />} />
            <Route path="/thema/:themeId/zelfscan" element={<SelfScan />} />
            <Route path="/thema/:themeId/toets" element={<Toets />} />
            <Route path="/voortgang" element={<Voortgang />} />
            <Route path="/certificaten" element={<Certificaten />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;
